import * as React from 'react';
const { useState, useEffect, useCallback } = React;

const LOADING_TIMEOUT = 30000;

const LoadingScreen = ({
  type = 'default',
  error = null,
  customMessage = '',
  onTimeout = () => {},
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((p) => Math.min(p + Math.random() * 4, 100));
    }, 200);
    const timeoutId = setTimeout(onTimeout, LOADING_TIMEOUT);
    return () => { clearInterval(progressInterval); clearTimeout(timeoutId); };
  }, [onTimeout]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-primary)' }}>
        <div className="neon-card p-8 max-w-md w-full mx-4">
          <div className="w-12 h-12 rounded-xl bg-red-50 dark:bg-red-900/20 flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
          </div>
          <h2 className="text-lg font-semibold text-center text-gray-900 dark:text-white mb-2">Something went wrong</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center mb-6">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="w-full py-2.5 rounded-xl text-sm font-medium text-white bg-gradient-to-r from-brand-500 to-accent-500 hover:from-brand-400 hover:to-accent-400 shadow-glow-sm transition-all"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-primary)' }}>
      <div className="flex flex-col items-center gap-6">
        {/* Spinner */}
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-2 border-gray-200 dark:border-white/[0.06]" />
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-brand-500 animate-spin" />
        </div>
        {/* Text */}
        <div className="text-center">
          <p className="text-sm font-medium text-gray-900 dark:text-white mb-1">
            {customMessage || (progress >= 100 ? 'Almost ready...' : 'Loading...')}
          </p>
          <p className="text-xs text-gray-400 dark:text-gray-500">Preparing your workspace</p>
        </div>
        {/* Progress */}
        <div className="w-48 h-1 rounded-full bg-gray-100 dark:bg-white/[0.04] overflow-hidden">
          <div
            className="h-full rounded-full bg-gradient-to-r from-brand-400 to-accent-400 transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
